export enum CommissionType {
  People = 1,
  Total = 2
};